import React from 'react';
import type { AdminDownloadGuideSectionProps } from '../../types/admin';

// Document Icon Component
const DocumentIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M8,12V14H16V12H8Z M8,16V18H13V16H8Z"/>
  </svg>
);

// Download Icon Component
const DownloadIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"/>
  </svg>
);

const AdminDownloadGuideSection: React.FC<AdminDownloadGuideSectionProps> = ({
  onDownload, 
  onBackToLogin, 
  className = '' 
}) => {
  const handleDownload = () => {
    onDownload();
  };

  const handleBackToLogin = () => {
    onBackToLogin();
  };

  return (
    <div className={`admin-section admin-download-guide-section ${className}`}>
      <h2 className="admin-section-title">Download User Guide</h2>
      
      <div className="admin-download-guide-icon-container">
        <DocumentIcon className="admin-download-guide-icon" />
      </div>
      
      <p className="admin-download-guide-description">
        Get comprehensive instructions on how to use the Pacific Cross Admin Portal
      </p>
      
      <button 
        type="button" 
        className="admin-section-button admin-download-guide-button admin-button-gradient"
        onClick={handleDownload}
      >
        <DownloadIcon className="admin-download-icon" />
        DOWNLOAD PDF GUIDE
      </button>
      
      <div 
        className="admin-back-link"
        onClick={handleBackToLogin}
      >
        ← Back to Login
      </div>
    </div>
  );
};

export default AdminDownloadGuideSection;